module.exports = __webpack_public_path__ + "media/images/icon_reply-b5e28e1fe6acd4ec003e643e947f1c4a.svg";